import React, { useState } from 'react';
import { adminAPI } from '../services/api';

const ManualDepositModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    amount: '',
    payment_method: 'cashapp',
    reference_note: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await adminAPI.createManualDeposit(formData);
      
      if (response && response.message) {
        setReferenceNumber(response.reference_number);
        setSubmitted(true);
      }
    } catch (error) {
      console.error('Error submitting manual deposit:', error);
      alert('Error submitting deposit request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ amount: '', payment_method: 'cashapp', reference_note: '' });
    setSubmitted(false);
    setReferenceNumber('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        maxWidth: '400px',
        width: '100%',
        margin: '16px',
        maxHeight: '90vh',
        overflow: 'auto'
      }}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
          <h2 style={{fontSize: '20px', fontWeight: 'bold', margin: 0}}>Manual Deposit</h2>
          <button onClick={handleClose} style={{color: '#6b7280', background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer'}}>
            ✕
          </button>
        </div>

        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom: '16px'}}>
              <label style={{display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px'}}>
                Amount ($)
              </label>
              <input
                type="number"
                step="0.01"
                min="0.01"
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                style={{width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', outline: 'none'}}
                required
              />
            </div>

            <div style={{marginBottom: '16px'}}>
              <label style={{display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px'}}>
                Payment Method
              </label>
              <select
                value={formData.payment_method}
                onChange={(e) => setFormData({ ...formData, payment_method: e.target.value })}
                style={{width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', outline: 'none'}}
              >
                <option value="cashapp">Cash App</option>
                <option value="zelle">Zelle</option>
              </select>
            </div>

            <div style={{marginBottom: '16px'}}>
              <label style={{display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px'}}>
                Reference Note (Optional)
              </label>
              <input
                type="text"
                value={formData.reference_note}
                onChange={(e) => setFormData({ ...formData, reference_note: e.target.value })}
                placeholder="Your CashApp name or Zelle Identifier"
                style={{width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', outline: 'none'}}
              />
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
              <button
                type="button"
                onClick={handleClose}
                style={{padding: '8px 16px', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', background: 'white', cursor: 'pointer'}}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading || !formData.amount}
                style={{padding: '8px 16px', backgroundColor: '#2563eb', color: 'white', borderRadius: '6px', border: 'none', cursor: 'pointer', opacity: (loading || !formData.amount) ? 0.5 : 1}}
              >
                {loading ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>
          </form>
        ) : (
          <div>
            <div style={{marginBottom: '16px', padding: '16px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '6px'}}>
              <h3 style={{fontSize: '18px', fontWeight: '600', color: '#166534', marginBottom: '8px', margin: '0 0 8px 0'}}>
                Deposit Request Submitted!
              </h3>
              <p style={{color: '#15803d', margin: 0}}>
                Your request for ${formData.amount} via {formData.payment_method === 'cashapp' ? 'Cash App' : 'Zelle'} has been submitted.
              </p>
            </div>

            <div style={{marginBottom: '16px', padding: '16px', backgroundColor: '#fef3c7', border: '1px solid #f59e0b', borderRadius: '6px'}}>
              <h4 style={{fontWeight: '600', color: '#92400e', marginBottom: '12px', margin: '0 0 12px 0'}}>
                📱 Payment Instructions
              </h4>
              <div style={{color: '#92400e'}}>
                <p style={{margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600'}}>
                  Send <strong>${formData.amount}</strong> to ooowap's {formData.payment_method === 'cashapp' ? 'Cash App' : 'Zelle'} account
                </p>
                <p style={{margin: '0 0 8px 0', fontSize: '14px'}}>
                  <strong>Reference Number:</strong> #{referenceNumber}
                </p>
                <p style={{margin: '0 0 8px 0', fontSize: '14px'}}>
                  <strong>Important:</strong> Include reference #{referenceNumber} in your payment note
                </p>
                <p style={{margin: 0, fontSize: '12px', fontStyle: 'italic'}}>
                  We will credit your account once we receive and verify the payment.
                </p>
              </div>
            </div>

            <div style={{marginBottom: '16px', padding: '16px', backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '6px'}}>
              <h4 style={{fontWeight: '600', color: '#1e40af', marginBottom: '8px', margin: '0 0 8px 0'}}>
                Send funds to:
              </h4>
              <div style={{color: '#1d4ed8'}}>
                {formData.payment_method === 'cashapp' ? (
                  <div>
                    <p style={{margin: '0 0 4px 0'}}><strong>Cash App Tag:</strong> $Toddshoes</p>
                    <p style={{fontSize: '14px', margin: '4px 0 0 0'}}>Send to this Cash App tag with reference #{referenceNumber}</p>
                  </div>
                ) : (
                  <div>
                    <p style={{margin: '0 0 4px 0'}}><strong>Zelle Email:</strong> TMshoresllc@gmail.com</p>
                    <p style={{fontSize: '14px', margin: '4px 0 0 0'}}>Send to this Zelle email with reference #{referenceNumber}</p>
                  </div>
                )}
              </div>
            </div>

            <div style={{marginBottom: '16px', padding: '16px', backgroundColor: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: '6px'}}>
              <h4 style={{fontWeight: '600', color: '#374151', marginBottom: '12px', margin: '0 0 12px 0'}}>
                ⚠️ Important Information
              </h4>
              <div style={{fontSize: '13px', color: '#4b5563', lineHeight: '1.5'}}>
                <p style={{margin: '0 0 6px 0'}}>• Take a photo of your deposit as your personal proof</p>
                <p style={{margin: '0 0 6px 0'}}>• If submitted correctly funds are 100% secured</p>
                <p style={{margin: '0 0 6px 0'}}>• Withdraws are done either through Cash App or Zelle only</p>
                <p style={{margin: '0 0 6px 0'}}>• Misuse of the manual deposit tool may result in a ban</p>
                <p style={{margin: 0}}>• Any questions or concerns please refer to the contact us page</p>
              </div>
            </div>

            <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '16px'}}>
              <p style={{margin: '0 0 4px 0'}}>You will receive an email confirmation with these instructions.</p>
              <p style={{margin: 0}}>Check your email for the complete payment details.</p>
            </div>

            <button
              onClick={handleClose}
              style={{width: '100%', padding: '8px 16px', backgroundColor: '#2563eb', color: 'white', borderRadius: '6px', border: 'none', cursor: 'pointer'}}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManualDepositModal;
